import L from "leaflet";
import areaClient from "@apis/areaClient";
import { svgIcon } from "@/components/Leaflet/Map/Marker/SvgIcon";
import GeozoneIconDefault from "@images/default/geozone_icon_default.svg";
import {
  PruneCluster,
  PruneClusterForLeaflet,
} from "@/components/Leaflet/Map/PruneCluster/PruneCluster";
import { ClusterIcon } from "@/components/Leaflet/Map/Marker/ClusterIcon";

L.GeozoneLayer = L.FeatureGroup.extend({
  options: {},
  bounds: L.latLngBounds(),
  pruneCluster: null,

  updateData: function (orgIds, options) {
    var self = this;
    var polygons = [];

    // Initialize PruneCluster if not already done
    if (!self.pruneCluster) {
      self.pruneCluster = new PruneClusterForLeaflet(120, 20);

      // Set cluster to use shadowPane for lower z-index
      self.pruneCluster.options.pane = "shadowPane";

      PruneCluster.Cluster.ENABLE_MARKERS_LIST = true;
      self.pruneCluster.BuildLeafletClusterIcon = function (cluster) {
        let iconClassName = "cluster-svg-geozone";
        let markers = cluster.GetClusterMarkers();
        let _length = markers.length;

        var width = 24,
          textSize = 11;
        if (_length >= 500 && _length < 5000) {
          width = 36;
          textSize = 7;
        } else if (_length >= 5000) {
          width = 44;
          textSize = 6;
        }

        const svgString = `<svg width="${width}" height="${width}" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path id="cluster-bg" fill-rule="evenodd" clip-rule="evenodd" d="M11 0L21.7999 6V18L11 24L0.199951 18V6L11 0Z" fill="#37A857"></path>
            <text id="cluster-text" x="50%" y="50%" font-size="${textSize}" font-weight="bold" transform="translate(0, 3.5)" text-anchor="middle" fill="#ffffff">${_length}</text>
            </svg>
        `;
        return ClusterIcon({
          count: _length,
          svgString: svgString,
          className: iconClassName,
        });
      };

      self.pruneCluster.PrepareLeafletMarker = function (leafletMarker, data) {
        leafletMarker.setIcon(data.icon);

        // Set marker to use shadowPane for lower z-index
        leafletMarker.options.pane = "shadowPane";

        if (data.tooltip) {
          leafletMarker.unbindTooltip();
          leafletMarker.bindTooltip(data.tooltip, {
            permanent: true,
            direction: "top",
            className: "transparent-tooltip",
            offset: [0, -8],
          });
        }
        leafletMarker.deviceInfo = data.deviceInfo;
      };

      // Add cluster layer to map if map is available
      if (self._map) {
        self._map.addLayer(self.pruneCluster);
      }
    }

    areaClient.getAreaByOrgs(orgIds).then(
      ({ data }) => {
        self.clearLayers();
        const aggregatedTooltip = L.tooltip({
          sticky: true,
          offset: [0, -4],
        });

        let geozones = data.sort((a, b) => (a.surface > b.surface ? -1 : 1));

        // Clear existing markers from cluster
        self.pruneCluster.RemoveMarkers();

        for (var i = 0; i < geozones.length; i++) {
          var obj = geozones[i];

          if (
            obj.hideOnMap ||
            (options && +options.ignoreGeozoneId === obj.id)
          ) {
            continue;
          }

          var geozone = null;
          var centerPoint = null;

          if (obj.circleGeozone) {
            geozone = L.circle(
              [obj.circleGeozone.point.x, obj.circleGeozone.point.y],
              {
                pane: "overlayPane",
                color: obj.borderColor,
                weight: 1,
                fillColor: obj.contentColor,
                radius: obj.circleGeozone.radius,
                _type: "CIRCLE",
                name: obj.name,
              }
            );
            centerPoint = [
              obj.circleGeozone.point.x,
              obj.circleGeozone.point.y,
            ];
            // .bindTooltip(obj.name, { sticky: true, offset: [0, -4] });
            self.bounds.extend([
              obj.circleGeozone.point.x,
              obj.circleGeozone.point.y,
            ]);
          } else {
            var coordinates = obj.coordinates || [],
              path = [];
            for (var j = 0, len = coordinates.length; j < len; j++) {
              path.push([coordinates[j].x, coordinates[j].y]);
            }
            geozone = L.polygon(path, {
              pane: "overlayPane",
              weight: 1,
              fillColor: obj.contentColor,
              color: obj.borderColor,
              name: obj.name,
            });
            // Calculate center point for polygon
            const polygon = L.polygon(path);
            const center = polygon.getBounds().getCenter();
            centerPoint = [center.lat, center.lng];
            // .bindTooltip(obj.name, { sticky: true, offset: [0, -4] });
            self.bounds.extend(path);
          }

          // Create geozone icon marker and add to cluster
          if (centerPoint) {
            const icon = svgIcon({
              iconUrl: obj.icon
                ? obj.icon.includes("?")
                  ? obj.icon + "&includeMapTemplate=true"
                  : obj.icon + "?includeMapTemplate=true"
                : GeozoneIconDefault,
              id: obj.id,
              state: "geozone",
              iconAnchor: [10, 30],
            });

            const marker = new PruneCluster.Marker(
              centerPoint[0],
              centerPoint[1],
              {
                icon: icon,
                tooltip: obj.name,
              }
            );
            marker.data.deviceInfo = obj;
            marker.getLatLng = function () {
              return new L.latLng(centerPoint[0], centerPoint[1]);
            };

            self.pruneCluster.RegisterMarker(marker);
          }

          geozone.on("mousemove", (event) => {
            // const currentPolygon = event.target;
            const latlng = event.latlng;
            const overlappingPolygons = self.findPolygonsContainPoint(
              latlng,
              polygons
            );
            const titles = overlappingPolygons.map(
              (polygon) => polygon.options.name
            );
            self.updateAggregatedTooltip(titles, latlng, aggregatedTooltip);
            self.addLayer(aggregatedTooltip);
          });

          // Add mouseout event listener to hide all tooltips
          geozone.on("mouseout", () => {
            self.removeLayer(aggregatedTooltip);
          });

          polygons.push(geozone);
          self.addLayer(geozone);
        }

        // Process the cluster view
        self.pruneCluster.ProcessView();
      },
      (err) => {
        // setLoading(false);
      }
    );
  },

  onAdd: function (map) {
    this._map = map;
    if (this.pruneCluster) {
      map.addLayer(this.pruneCluster);
    }
    L.FeatureGroup.prototype.onAdd.call(this, map);
  },

  onRemove: function (map) {
    this._map = null;
    if (this.pruneCluster) {
      map.removeLayer(this.pruneCluster);
    }
    L.FeatureGroup.prototype.onRemove.call(this, map);
  },

  pointInsidePolygon: function (point, polygon) {
    let inside = false;
    const x = point.lat;
    const y = point.lng;

    if (polygon instanceof L.Circle) {
      return polygon.getBounds().contains(point); // For circles, use bounds.contains
    }

    for (var ii = 0; ii < polygon.getLatLngs().length; ii++) {
      var polyPoints = polygon.getLatLngs()[ii];
      for (
        var i = 0, j = polyPoints.length - 1;
        i < polyPoints.length;
        j = i++
      ) {
        var xi = polyPoints[i].lat,
          yi = polyPoints[i].lng;
        var xj = polyPoints[j].lat,
          yj = polyPoints[j].lng;

        var intersect =
          yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
        if (intersect) inside = !inside;
      }
    }

    return inside;
  },
  updateAggregatedTooltip: function (titles, latlng, aggregatedTooltip) {
    const tooltipContent = titles.join("<br>"); // Join titles with line breaks
    aggregatedTooltip.setContent(tooltipContent);
    aggregatedTooltip.setLatLng(latlng);
  },
  findPolygonsContainPoint: function (latlng, polygons) {
    const overlappingPolygons = [];

    polygons.forEach((polygon) => {
      if (this.pointInsidePolygon(latlng, polygon)) {
        overlappingPolygons.push(polygon);
      }
    });

    return overlappingPolygons;
  },
  getLayer: function () {
    return this;
  },
  getBounds: function () {
    return this.bounds;
  },
});

L.geozoneLayer = function (opts) {
  return new L.GeozoneLayer(opts);
};
export const GeozoneLayer = L.geozoneLayer;
